import classNames from 'classnames'
import * as React from 'react'

import SvgIcon from '../../../../common/SvgIcon/SvgIcon'

import styles from './UnauthorizedAgentsCounter.css'

type Props = {
  counterClassName?: string
  count: number
}
export default function UnauthorizedAgentsCounter({count, counterClassName}: Props) {
  return (
    <>
      <SvgIcon
        className={styles.icon}
        icon="unauthorized"
        title="unauthorized"
        data-test-unauthorized-agents-counter={'icon'}
      />
      <span
        className={classNames(styles.counter, counterClassName)}
        data-test-unauthorized-agents-counter={'count'}
      >
        {count}
      </span>
    </>
  )
}
